export default __webpack_public_path__ + "static/media/bread_img.4bd2590d.png";